<div class="container-fluid">
  <div class="row">
    <div class="col-xl-4 col-lg-3"></div>
    <div class="col-xl-4 col-lg-6">
      <div class="row">
        <div class="col-12">
          <div class="card mb-3">
            <div class="card-header">
              <fa-icon [icon]="['fas', 'cog']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>ADMIN - Logga in som annan person
            </div>
            <div class="card-body">
              <form [formGroup]="loginForm">
                <div class="mb-3">
                  <label for="personal_number">Personnummer</label>
                  <div class="input-group mb-3">
                    <span class="input-group-text">
                        <fa-icon [icon]="['fas', 'passport']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                      </span>
                    <input type="text" name="personal_number" id="personal_number" class="form-control rounded-end" [attr.placeholder]="'placeholder.personnr' | translate" formControlName="personal_number" [class.is-invalid]="personal_number.dirty && personal_number.invalid">
                    <div class="invalid-tooltip">
                      @if (personal_number.errors?.isEmpty) {
                        <span>{{ 'label.ogiltigt-personnr-tomt' | translate }}</span>
                      }
                      @if (personal_number.errors?.invalidBirthday) {
                        <span>{{ 'label.ogiltigt-personnr-fodelsedag' | translate }}</span>
                      }
                      @if (personal_number.errors?.invalidFormat) {
                        <span>{{ 'label.ogiltigt-personnr-format' | translate }}</span>
                      }
                      @if (personal_number.errors?.invalidCheckDigit) {
                        <span>{{ 'label.ogiltigt-personnr-checksiffra' | translate }}</span>
                      }
                    </div>
                  </div>
                </div>
                <div class="mb-0">
                  <input class="btn-garanti btn-pink w-100" type="button" value="Logga in med mobilt BankID (QR-kod)" (click)="loginMobileBankId()" [disabled]="loginForm.invalid" />
                  <input class="btn-garanti btn-pink w-100" type="button" value="Logga in med BankID på fil" (click)="loginBankIdOnFile()" [disabled]="loginForm.invalid" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
